import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'auth/AuthContext'

const navStyle = 'px-4 py-2 text-gray-600 transition rounded-t-md border border-b-0'
const navActive = 'bg-white border-gray-300 font-semibold text-greenPrimary -mb-[1px]'
const navHover = 'hover:bg-gray-100 hover:text-greenPrimary border-transparent'
const navDisabled = 'opacity-50 cursor-not-allowed pointer-events-none'

const NavTabs = ({ tabs = [], checkPermissions = false }) => {
  const { user } = useAuth()
  const { t } = useTranslation()
  const userPermissions = user?.permissions || []

  const isActiveNav = ({ isActive }) =>
    [navStyle, isActive ? navActive : navHover].join(' ')

  return (
    <nav className='sticky top-0 z-20 flex gap-2 shadow-sm border-b border-gray-300 bg-white'>
      {tabs.map(({ labelKey, to, permission }) => {
        const hasPermission = !checkPermissions || userPermissions.includes(permission)

        return (
          <NavLink
            key={to}
            to={to}
            className={props => `${isActiveNav(props)} ${!hasPermission ? navDisabled : ''}`}
            onClick={e => {
              if (!hasPermission) e.preventDefault()
            }}
          >
            {t(labelKey)}
          </NavLink>
        )
      })}
    </nav>
  )
}

export default NavTabs
